import tvlogo from "../../media/accTV.png";
import acadlogo from "../../media/acc-Academy.png";
import irdlogo from "../../media/iRdrive-logo.png";
import lmudlogo from "../../media/lmudrive-logo.png";
import lmutvlogo from "../../lmutv/media/lmuTV.png";
import drivelogo from "../../media/drive-logo.png";
import acdrivelogo from "../../media/acdrive-logo.png";
import { AppCard } from "./AppCards";
import { useTranslation } from "react-i18next";
import { Center, SimpleGrid } from "@mantine/core";

export const appCardList = {
  apps: [
    {
      id: "accdrive",
      url: "https://accdrive.com",
      front: {
        logo: drivelogo,
        color: "#3B902C"
      },
      back: {
        name: "ACC DRIVE",
        text: ""
      }
    },
    {
      id: "academy",
      url: "https://academy.accsolutions.de",
      front: {
        logo: acadlogo,
        color: "#FFC03B"
      },
      back: {
        name: "ACADEMY",
        text: ""
      }
    },
    {
      id: "acctv",
      url: "https://acctv.de",
      front: {
        logo: tvlogo,
        color: "#FF7D3B"
      },
      back: {
        name: "ACC TV",
        text: ""
      }
    },
    {
      id: "irdrive",
      url: "https://irdrive.accsolutions.de",
      front: {
        logo: irdlogo,
        color: "#2064E9"
      },
      back: {
        name: "IR DRIVE",
        text: ""
      }
    },
    {
      id: "lmudrive",
      url: "https://lmudrive.com",
      front: {
        logo: lmudlogo,
        color: "#080C08"
      },
      back: {
        name: "LMU DRIVE",
        text: ""
      }
    },
    {
      id: "lmutv",
      url: "/lmutv",
      front: {
        logo: lmutvlogo,
        color: "#99180D"
      },
      back: {
        name: "LMU TV",
        text: ""
      }
    },
    {
      id: "acdrive",
      url: "/acdrive",
      front: {
        logo: acdrivelogo,
        color: "#548e19"
      },
      back: {
        name: "AC DRIVE",
        text: ""
      }
    },
  ]
};

export function AppCardList() {
  const { t } = useTranslation("translation");
  
  const appCards = appCardList.apps.map((app) => {
    return (
      <AppCard
        key={app.id}
        url={app.url}
        front={app.front}
        back={{
          name: t(`apps.${app.id}.name`),
          text: t(`apps.${app.id}.text`),
        }}
      />
    );
  });
  
  return (
    <Center style={{ padding: '2rem 0' }}>
      <SimpleGrid
        cols={{ base: 1, sm: 2, lg: 3 }}
        spacing={{ base: 'lg', sm: 'xl', lg: 45 }}
        verticalSpacing={{ base: 'xl', lg: 50 }}
        style={{ 
          maxWidth: "1800px", 
          width: '100%',
          padding: '0 1rem'
        }}
      >
        {appCards}
      </SimpleGrid>
    </Center>
  );
}